import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MaterialModule } from "../../../core/shared/material.module";
import { TableViewModalComponent } from "../../modal-templates/table-view-modal/table-view-modal.component";
import { SharedComponents } from "../../shared.module";

@Component({
  selector: "app-table-view",
  standalone: true,
  imports: [CommonModule, ...SharedComponents, FormsModule, MaterialModule],
  templateUrl: "./table-view.component.html",
  styleUrl: "./table-view.component.scss",
})
export class TableViewComponent {
  @Input() columns: any[] = [];
  @Input() data: any = [];

  @Input() config: any = {};
  @Input() metric: any = {};


  private modalService = inject(NgbModal);

  sortedColumn: string = "";
  sortOrder: "asc" | "desc" = "asc";
  originalData: any[] = [];
  selectedImpact = "";
  dropdownOptions: any = [];

  ngOnInit(): void {
    this.getImpactList();
    this.originalData = [...this.data];
    console.log(this.columns);
    if (!this.columns || !this.data) {
      console.warn("Columns and data inputs are required for TableComponent");
    }

    if (this.dropdownOptions?.length > 0) {
      this.selectedImpact = this.dropdownOptions[0];
    }
  }

  /**
   * Extracts nested data based on the column key.
   * Handles nested keys like 'key1.key2'.
   */
  getNestedData(row: any, key: string): any {
    if (!key) return "";
    return key.split(".").reduce((acc, part) => acc && acc[part], row) || "";
  }

  /**
   * Check if the column type is object-array
   */
  isObjectArrayColumn(column: any): boolean {
    return column.type === "object-array";
  }

  /**
   * Determine if rowspan should be rendered for the given row index.
   */
  shouldRenderRowspan(data: any[], rowIndex: number): boolean {
    return (
      rowIndex === 0 || data[rowIndex].impact !== data[rowIndex - 1].impact
    );
  }

  /**
   * Calculate rowspan for a specific impact value.
   */
  getRowspan(data: any[], impact: string): number {
    return data.filter((row) => row.impact === impact).length;
  }

  getColumns(columns: any) {
    return columns?.filter((item: any) => !item.rowspan);
  }

  /**
   * Handle updates to the textarea and update table data.
   */
  onTextareaChange(row: any, key: string, updatedValue: any): void {
    row[key] = updatedValue;
    console.log(`Updated row data:`, row);
  }

  /**
   * Handle sorting
   */
  sortTable(columnKey: string) {
    if (this.sortedColumn === columnKey) {
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
    } else {
      this.sortedColumn = columnKey;
      this.sortOrder = "asc";
    }

    this.data.sort((a: any, b: any) => {
      const valueA = this.getNestedDataForSorting(a, columnKey);
      const valueB = this.getNestedDataForSorting(b, columnKey);

      if (typeof valueA === "string" && typeof valueB === "string") {
        return this.sortOrder === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      } else {
        return this.sortOrder === "asc" ? valueA - valueB : valueB - valueA;
      }
    });
  }

  /**
   * Handle sorting
   */
  getNestedDataForSorting(obj: any, path: string) {
    return path.split(".").reduce((o, k) => (o || {})[k], obj);
  }

  getImpactList() {
    this.dropdownOptions = [];
    this.data.forEach((element: any) => {
      if (element?.impact) { this.dropdownOptions.push(element.impact); }
    });
  }

  onDropdownChange() {
    if (this.selectedImpact) {
      this.data = this.originalData.filter(
        (row) => row.impact === this.selectedImpact
      );
    } else {
      this.data = [...this.originalData]; // Reset to original data when no selection
    }
  }

  viewAll() {
    const modalRef = this.modalService.open(TableViewModalComponent, {
      centered: true,
      windowClass: "secondary-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.title = this.metric?.metricDisplayName ? this.metric?.metricDisplayName : "Test Case to Source Code Mapping";
    modalRef.componentInstance.tableData = {
      columns: this.columns,
      rows: this.data
    };
  }

  getData() {
    return this.config?.maxRows && this.data.length > this.config.maxRows ? this.data.slice(0, this.config.maxRows) : this.data; 
  }

  getLozengeClass(value:any){
    switch (value){
      case "critical":
      return "critical-priority";

      case "high":
      return "high-priority";
      
      case "medium":
      return "medium-priority";
        
      case "low":
      return "low-priority";

      case "major":
      return "major-priority";

      case "minor":
      return "minor-priority";
        
      default:
      return "default-priority";
    }
  }
}
